module.exports = __webpack_public_path__ + "assets/img/img-content-none01.a24e59a9.png";